/* Language switcher — Arabic ↔ English
   - Detects language from Shopify's /ar/ locale URL prefix
   - setLang() redirects to /ar/path or /path — Shopify serves ar.json automatically
   - Translates [data-i18n] elements (custom strings not covered by ar.json)
   - Dropdown 🇬🇧 EN / 🇸🇦 AR in nav (desktop + mobile)
   - Exposes window.FG_LANG.{get, set, navLabel(ar,url), countryLabel(code)}
     country-popup.js reads these to translate nav + country dropdown
*/
(function () {
  'use strict';

  var LANG_KEY = 'fg_lang';
  var DEFAULT  = 'en';

  /* ── Translatable strings ──────────────────────────────────────── */
  var STRINGS = {
    ar: {
      'popup.heading': 'اختر منطقتك',
      'country.uae':   '🇦🇪 الإمارات العربية المتحدة',
      'country.sa':    '🇸🇦 السعودية',
      'country.bh':    '🇧🇭 البحرين',
      'country.kw':    '🇰🇼 الكويت',
      'country.qa':    '🇶🇦 قطر',
      'country.om':    '🇴🇲 عُمان',
      'country.lb':    '🇱🇧 لبنان',
      'country.jo':    '🇯🇴 الأردن',
      'country.iq':    '🇮🇶 العراق',
      'country.eg':    '🇪🇬 مصر',
      'country.row':   '🌍 باقي دول العالم',
      'popup.welcome': 'أهلاً بكم في متجر فليرقن الرسمي 🎮',
      'popup.group.noon':  'الخليج — تسوّق على',
      'popup.group.other': 'مناطق أخرى'
    },
    en: {
      'popup.heading': 'Choose Your Region',
      'country.uae':   '🇦🇪 UAE',
      'country.sa':    '🇸🇦 Saudi Arabia',
      'country.bh':    '🇧🇭 Bahrain',
      'country.kw':    '🇰🇼 Kuwait',
      'country.qa':    '🇶🇦 Qatar',
      'country.om':    '🇴🇲 Oman',
      'country.lb':    '🇱🇧 Lebanon',
      'country.jo':    '🇯🇴 Jordan',
      'country.iq':    '🇮🇶 Iraq',
      'country.eg':    '🇪🇬 Egypt',
      'country.row':   '🌍 Rest of the World',
      'popup.welcome': 'Welcome to the Official FlaregunTV Shop 🎮',
      'popup.group.noon':  'Gulf — shop on',
      'popup.group.other': 'Other regions'
    }
  };

  /* Fallback: Arabic label text → English (for manual nav blocks) */
  var NAV_EN = {
    'الرئيسية':         'Store',
    'العروض':           'Offers',
    'مراوح تبريد':      'Fan Coolers',
    'سماعات':           'Headsets',
    'شفتات':            'Triggers',
    'إكسسوار':          'Accessories',
    'أكمام':            'Sleeves',
    'محولات':           'Adapters',
    'شواحن':            'Chargers',
    'مجموعات':          'Collections'
  };

  /* Primary: URL segment keyword → English (handles auto-discovered collections
     whose Arabic titles may not exactly match the lookup above) */
  var URL_EN = [
    ['fan-cooler',     'Fan Coolers'],
    ['headset',        'Headsets'],
    ['trigger',        'Triggers'],
    ['accessor',       'Accessories'],
    ['sleeve',         'Sleeves'],
    ['adapter',        'Adapters'],
    ['charger',        'Chargers'],
    ['offer',          'Offers'],
    ['collections',    'Collections']
  ];

  /* Country name maps */
  var COUNTRY_EN = {
    uae: 'UAE',     sa: 'Saudi Arabia', bh: 'Bahrain', kw: 'Kuwait', qa: 'Qatar', om: 'Oman',
    lb:  'Lebanon',
    jo:  'Jordan',  iq: 'Iraq',    eg: 'Egypt',
    row: 'Rest of the World'
  };
  var COUNTRY_AR = {
    uae: 'الإمارات العربية المتحدة', sa: 'السعودية', bh: 'البحرين', kw: 'الكويت', qa: 'قطر', om: 'عُمان',
    lb:  'لبنان',
    jo:  'الأردن',                   iq: 'العراق',  eg: 'مصر',
    row: 'باقي دول العالم'
  };

  /* ── Public API — set before DOMContentLoaded ────────────────────── */
  window.FG_LANG = {
    get: getLang,
    set: setLang,
    navLabel: function (ar, url) {
      if (getLang() !== 'en') return ar;
      /* Try URL segment first — more reliable than Arabic string matching */
      if (url) {
        var seg = (url.split('/').pop() || '').toLowerCase();
        for (var i = 0; i < URL_EN.length; i++) {
          if (seg.indexOf(URL_EN[i][0]) !== -1) return URL_EN[i][1];
        }
      }
      return NAV_EN[ar] || ar;
    },
    countryLabel: function (code) {
      return getLang() === 'en' ? (COUNTRY_EN[code] || code) : (COUNTRY_AR[code] || code);
    }
  };

  /* ── Core ────────────────────────────────────────────────────────── */
  function getLang() {
    try {
      /* Shopify's served locale is the source of truth */
      if (window.Shopify && window.Shopify.locale === 'ar') return 'ar';
      if (/^\/ar(\/|$)/.test(location.pathname)) return 'ar';
      return localStorage.getItem(LANG_KEY) || DEFAULT;
    } catch (e) { return DEFAULT; }
  }

  function setLang(lang) {
    try { localStorage.setItem(LANG_KEY, lang); } catch (e) {}
    var path = location.pathname.replace(/^\/ar(\/|$)/, '/');
    var qs   = (location.search || '').replace(/[?&]lang=[^&]*/g, '').replace(/^&/, '?');
    /* Use the pre-rendered Shopify localization form (CSRF token already baked in) */
    var form       = document.getElementById('fg-locale-form');
    var codeInput  = document.getElementById('fg-locale-code');
    var retInput   = document.getElementById('fg-locale-return');
    if (form && codeInput && retInput) {
      codeInput.value = lang;
      retInput.value  = path + qs;
      /* Bypass any JS override of .submit() (e.g. Debutify AJAX interception) */
      HTMLFormElement.prototype.submit.call(form);
    } else {
      /* Fallback: direct navigation via Shopify's localization endpoint */
      var dest = lang === 'ar' ? ('/ar' + path + qs) : (path + qs || '/');
      window.location.href = dest;
    }
  }

  function applyLang(lang) {
    /* Translate data-i18n elements */
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var val = (STRINGS[lang] || {})[el.getAttribute('data-i18n')];
      if (val != null) el.textContent = val;
    });
    /* Update only fg-lang-wrap dropdowns (not the Shopify locale nav button) */
    document.querySelectorAll('.fg-lang-wrap .fg-lang-current').forEach(function (el) {
      el.textContent = lang === 'en' ? '🇬🇧 EN' : '🇸🇦 AR';
    });
    document.querySelectorAll('.fg-lang-option').forEach(function (btn) {
      btn.classList.toggle('fg-lang-option--active', btn.getAttribute('data-fg-lang') === lang);
    });
    /* Re-render nav and country switcher with new language */
    if (typeof window.FG_NAV_REFRESH      === 'function') window.FG_NAV_REFRESH();
    if (typeof window.FG_SWITCHER_REFRESH === 'function') window.FG_SWITCHER_REFRESH();
  }

  /* ── Dropdown widget ─────────────────────────────────────────────── */
  function buildSwitcherHTML(lang) {
    var cur  = lang === 'en' ? '🇬🇧 EN' : '🇸🇦 AR';
    var enAct = lang === 'en' ? ' fg-lang-option--active' : '';
    var arAct = lang === 'ar' ? ' fg-lang-option--active' : '';
    return (
      '<button class="fg-lang-toggle" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="fg-lang-current">' + cur + '</span>' +
        '<span class="fg-lang-arrow" aria-hidden="true">▾</span>' +
      '</button>' +
      '<div class="fg-lang-dropdown" role="listbox">' +
        '<button class="fg-lang-option' + enAct + '" data-fg-lang="en" role="option">🇬🇧 EN</button>' +
        '<button class="fg-lang-option' + arAct + '" data-fg-lang="ar" role="option">🇸🇦 AR</button>' +
      '</div>'
    );
  }

  function mountSwitcher(container, wrapClass) {
    if (!container || container.querySelector('.fg-lang-wrap')) return;
    var lang = getLang();
    var wrap = document.createElement('div');
    wrap.className = 'fg-lang-wrap' + (wrapClass ? ' ' + wrapClass : '');
    wrap.innerHTML = buildSwitcherHTML(lang);

    var toggle   = wrap.querySelector('.fg-lang-toggle');
    var dropdown = wrap.querySelector('.fg-lang-dropdown');

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.toggle('fg-lang-dropdown--open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      var btn = e.target.closest ? e.target.closest('.fg-lang-option') : null;
      if (!btn && e.target.classList && e.target.classList.contains('fg-lang-option')) btn = e.target;
      if (!btn) return;
      dropdown.classList.remove('fg-lang-dropdown--open');
      toggle.setAttribute('aria-expanded', 'false');
      setLang(btn.getAttribute('data-fg-lang'));
    });

    container.appendChild(wrap);
  }

  /* Single document listener closes all open dropdowns */
  document.addEventListener('click', function () {
    document.querySelectorAll('.fg-lang-dropdown--open').forEach(function (d) {
      d.classList.remove('fg-lang-dropdown--open');
    });
    document.querySelectorAll('.fg-lang-toggle[aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }, { passive: true });

  /* ── Init ────────────────────────────────────────────────────────── */
  function mount() {
    mountSwitcher(document.getElementById('fg-lang-nav-mount'),    'fg-lang-wrap--nav');
    mountSwitcher(document.getElementById('fg-lang-mobile-mount'), 'fg-lang-wrap--mobile');
  }

  function init() {
    var lang = getLang();
    /* Clean up stale ?lang= params left over from old approach */
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('lang')) {
        u.searchParams.delete('lang');
        history.replaceState(null, '', u.toString());
      }
    } catch (e) {}
    applyLang(lang);
    mount();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);
  document.addEventListener('shopify:section:load', function () { applyLang(getLang()); mount(); });
})();
